import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../common/tab/tabActions';
import { getConfig, setConfig } from '../configuracao/configLocal';

let INITIAL_VALUES = {
  ativo: 1,
  controlador_mestre_id: 0,
  numero_controlador: 0,
  anel: 1, // sempre seleciona no cbx o anel 1

  // AQUI REPETE TUDO QUE TEM NO ARRAY[0] DE ANEIS
  tempo_vermelho_min: 1,
  tempo_amarelo_min: 3,
  tempo_verde_min: 3,
  numero_fases: 0,
  numero_fases_fim: 0, // para gerar o grid em branco
  nobreak: 0,
  // fases: [],
  aneis: [
    // cadastra com 4 aneis porém só o anel 1 fica ativo
    {
      anel: 1,
      endereco: '',
      cruzamento: '',
      numero_fases: 0,
      numero_fases_fim: 0,
      tempo_vermelho_min: 1,
      tempo_amarelo_min: 3,
      tempo_verde_min: 3,
      ativo: 1,
      fases: [],
      imageLog: 'in',
    },
    {
      anel: 2,
      endereco: '',
      cruzamento: '',
      numero_fases: 0,
      numero_fases_fim: 0,
      tempo_vermelho_min: 1,
      tempo_amarelo_min: 3,
      tempo_verde_min: 3,
      ativo: 0,
      fases: [],
      imageLog: 'in',
    },
    {
      anel: 3,
      endereco: '',
      cruzamento: '',
      numero_fases: 0,
      numero_fases_fim: 0,
      tempo_vermelho_min: 1,
      tempo_amarelo_min: 3,
      tempo_verde_min: 3,
      ativo: 0,
      fases: [],
      imageLog: 'in',
    },
    {
      anel: 4,
      endereco: '',
      cruzamento: '',
      numero_fases: 0,
      numero_fases_fim: 0,
      tempo_vermelho_min: 1,
      tempo_amarelo_min: 3,
      tempo_verde_min: 3,
      ativo: 0,
      fases: [],
      imageLog: 'in',
    },
  ],
};

export function getList() {
  const request = axiosInstance.get(`/controladores/${getConfig('grupo')}`);
  return {
    type: 'CONTROLADOR_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'CONTROLADOR_PAGE',
  payload: pagina,
});

export async function getFaseList(contid, faseIni, faseFin) {
  const request = await axiosInstance.get(`/fases/${contid}/${faseIni}/${faseFin}`);
  return {
    type: 'FASE_FETCHED',
    payload: request,
  };
}

export function getFaseListNovo(faseIni, faseFin) {
  const request = axiosInstance.get(`/fases/controlador/novo/${faseIni}/${faseFin}`);
  return {
    type: 'FASE_FETCHED',
    payload: request,
  };
}

export function create(values) {
  return submit(values, 'post');
}

export function update(values) {
  return submit(values, 'put');
}

export function remove(values) {
  return submit(values, 'delete');
}

function submit(values, method) {
  let cont_id = parseInt(values.id);
  let conf_id = parseInt(getConfig('cont'));

  values['grupo_fisico_id'] = getConfig('grupo');

  return async dispatch => {
    try {
      const id = values.id ? values.id : '';

      let URL = `/controladores/${id}`;
      if (method === 'delete') {
        URL = `/controladores/${values.grupo_fisico_id}/${values.numero_controlador}`;
        values = { data: values };
      }

      // Remove campos locais de UI que não devem ser enviados ao backend
      // Evita erro: "Unknown column 'dataHoraAnterior' in 'field list'"
      let payload = values;
      if (method !== 'delete') {
        payload = { ...values };
        delete payload.dataHoraAnterior;
        delete payload.dataHoraAtual;
        delete payload.versaoMCPControlador;

        // Converte valores boolean dos checkboxes para 0/1 para o banco
        payload.nobreak = payload.nobreak ? 1 : 0;
        payload.pluviometrico_ativo = payload.pluviometrico_ativo ? 1 : 0;
      }

      const resp = await axiosInstance[method](URL, payload);

      if (method === 'delete' && cont_id === conf_id) {
        setConfig('cont', 0);
        setConfig('numCont', 0);
      } else {
        setConfig('cont', values.id);
        setConfig('numCont', values.numero_controlador);
      }

      toastr.success('Sucesso', 'Operação Realizada com sucesso.');
      dispatch(init());
      return resp;
    } catch (e) {
      toastr.error('Erro', e);
      throw e;
    }
  };
}

// export function showFase(controlador) {

//     return [
//         initialize('controladorFaseList', controlador),
//         showTabs('tabFase'),
//         selectTab('tabFase')
//     ]
// }

export function showSAP(controlador) {
  return [showTabs('tabSAP'), selectTab('tabSAP'), initialize('controladorSAP', controlador)];
}

export function showUpdate(controlador) {
  return async dispatch => {
    try {
      // Busca dados de sincronização se o controlador tiver ID
      if (controlador.id) {
        const response = await axiosInstance.get(`/controladores/sincronizacao/${controlador.id}`);
        const sincronizacao = response.data;

        // Adiciona data/hora da verificação anterior e última verificação ao objeto do controlador
        if (sincronizacao.anterior && sincronizacao.anterior.dataHora) {
          controlador.dataHoraAnterior = sincronizacao.anterior.dataHora;
        }
        if (sincronizacao.ultimo && sincronizacao.ultimo.dataHora) {
          controlador.dataHoraAtual = sincronizacao.ultimo.dataHora;
        }
      }
    } catch (error) {
      console.error('Erro ao buscar sincronização:', error);
      // Continua mesmo se der erro na sincronização
    }

    const controladorNormalizado = {
      ...controlador,
      nobreak: Boolean(controlador.nobreak),
      pluviometrico_ativo: Boolean(controlador.pluviometrico_ativo),
    };

    // Inicializa o formulário com os dados do controlador (incluindo sincronização)
    dispatch([showTabs('tabUpdate'), selectTab('tabUpdate'), initialize('controladorForm', controladorNormalizado)]);
  };
}

export const getImageCroquiById = id => {
  return async dispatch => {
    try {
      const response = await axiosInstance.get(`/controladores/download/${id}`, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      console.error('Erro ao visualizar o croqui:', error);
      throw error;
    }
  };
};

export const downloadCroqui = croqui_file_id => {
  return async dispatch => {
    try {
      const response = await axiosInstance.get(`/controladores/download/${croqui_file_id}`, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      console.error('Erro ao baixar o croqui:', error);
      throw error;
    }
  };
};

export function showDelete(controlador) {
  return [showTabs('tabDelete'), selectTab('tabDelete'), initialize('controladorForm', controlador)];
}

export function init() {
  INITIAL_VALUES = {
    ativo: 1,
    controlador_mestre_id: 0,
    numero_controlador: 0,
    anel: 1, // sempre seleciona no cbx o anel 1

    // AQUI REPETE TUDO QUE TEM NO ARRAY[0] DE ANEIS
    tempo_vermelho_min: 1,
    tempo_amarelo_min: 3,
    tempo_verde_min: 3,
    numero_fases: 0,
    numero_fases_fim: 0, // para gerar o grid em branco
    nobreak: 0,
    // fases: [],
    aneis: [
      // cadastra com 4 aneis porém só o anel 1 fica ativo
      {
        anel: 1,
        endereco: '',
        cruzamento: '',
        numero_fases: 0,
        numero_fases_fim: 0,
        tempo_vermelho_min: 1,
        tempo_amarelo_min: 3,
        tempo_verde_min: 3,
        ativo: 1,
        fases: [],
      },
      {
        anel: 2,
        endereco: '',
        cruzamento: '',
        numero_fases: 0,
        numero_fases_fim: 0,
        tempo_vermelho_min: 1,
        tempo_amarelo_min: 3,
        tempo_verde_min: 3,
        ativo: 0,
        fases: [],
      },
      {
        anel: 3,
        endereco: '',
        cruzamento: '',
        numero_fases: 0,
        numero_fases_fim: 0,
        tempo_vermelho_min: 1,
        tempo_amarelo_min: 3,
        tempo_verde_min: 3,
        ativo: 0,
        fases: [],
      },
      {
        anel: 4,
        endereco: '',
        cruzamento: '',
        numero_fases: 0,
        numero_fases_fim: 0,
        tempo_vermelho_min: 1,
        tempo_amarelo_min: 3,
        tempo_verde_min: 3,
        ativo: 0,
        fases: [],
      },
    ],
  };
  return [
    showTabs('tabList', 'tabCreate'),
    selectTab('tabList'),
    getList(),
    initialize('controladorForm', INITIAL_VALUES),
  ];
}

export function testarConexao(enderecoUDP, numCont) {
  const ip = enderecoUDP.ip ? enderecoUDP.ip : '';
  const porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  const request = axiosInstance.get(`/controladores/cxudp/${ip}/${porta}/${numCont}`);

  return {
    type: 'CONEXAO_CONTROLE',
    payload: request,
  };
}

export function reset(enderecoUDP, numCont) {
  const ip = enderecoUDP.ip ? enderecoUDP.ip : '';
  const porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  const request = axiosInstance.get(`/controladores/reset/${ip}/${porta}/${numCont}`);

  return {
    type: '',
    payload: request,
  };
}

export function getSincronizacao(controladorId) {
  return axiosInstance.get(`/controladores/sincronizacao/${controladorId}`);
}

export function enviarRelogioControlador(enderecoUDP, numCont) {
  let ip = '0';
  let porta = 0;

  if (enderecoUDP) {
    ip = enderecoUDP.ip ? enderecoUDP.ip : '';
    porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  }

  const request = axiosInstance.get(`/controladores/enviarelogio/${ip}/${porta}/${numCont}`);

  return {
    type: '',
    payload: request,
  };
}

export function alteraMonitora(numero, value) {
  let values = {
    grupo: getConfig('grupo'),
    numero_controlador: numero,
    monitora_erro: value,
  };

  const request = axiosInstance.put(`/controladores/monitora`, values);

  return {
    type: '',
    payload: request,
  };
}

export function enviarTemposControlador(values) {
  const request = axiosInstance.put(`/controladores/temposeguranca/enviar`, values);

  return {
    type: '',
    payload: request,
  };
}

export function enviaDadosFasesControlador(values) {
  const request = axiosInstance.put(`/controladores/dadosfases/enviar`, values);

  return {
    type: '',
    payload: request,
  };
}

export function enviarHorarioVeraoControlador(values) {
  const request = axiosInstance.put(`/controladores/horarioverao/enviar`, values);

  return {
    type: '',
    payload: request,
  };
}

export function lerTemposControlador(enderecoUDP, numCont, anel) {
  let ip = '0';
  let porta = 0;

  if (enderecoUDP) {
    ip = enderecoUDP.ip ? enderecoUDP.ip : '';
    porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  }

  const request = axiosInstance.get(`/controladores/temposeguranca/${ip}/${porta}/${numCont}/${anel}`);

  return {
    type: '',
    payload: request,
  };
}

export function lerAneis(numero, grupo, incluirInativos = false) {
  const query = incluirInativos ? '?incluirInativos=1' : '';
  const request = axiosInstance.get(`/controladores/numero/${numero}/${grupo}${query}`);

  return {
    type: 'CONTROLADORANEIS_FETCHED',
    payload: request,
  };
}

export function lerQuantidadeAneis(enderecoUDP, numCont, anel) {
  let ip = '0';
  let porta = 0;

  if (enderecoUDP) {
    ip = enderecoUDP.ip ? enderecoUDP.ip : '';
    porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  }

  const request = axiosInstance.get(`/controladores/quantidadeaneis/${ip}/${porta}/${numCont}/${anel}`);

  return {
    type: '',
    payload: request,
  };
}

export function lerDadosFasesControlador(enderecoUDP, numCont, anel) {
  let ip = '0';
  let porta = 0;

  if (enderecoUDP) {
    ip = enderecoUDP.ip ? enderecoUDP.ip : '';
    porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  }

  const request = axiosInstance.get(`/controladores/dadosfases/${ip}/${porta}/${numCont}/${anel}`);

  return {
    type: '',
    payload: request,
  };
}

export function getLocalCEP(cep) {
  const request = axiosInstance.get(`/controladormap/${cep}`);

  return {
    type: '',
    payload: request,
  };
}

export function verifyNumberController(contId, enderecoUDP) {
  let ip = '0';
  let porta = 0;

  if (enderecoUDP) {
    ip = enderecoUDP.ip ? enderecoUDP.ip : '';
    porta = enderecoUDP.porta ? enderecoUDP.porta : '';
  }

  const request = axiosInstance.get(`/controladores/verificanumerocont/${ip}/${porta}/${contId}`);

  return {
    type: '',
    payload: request,
  };
}

export function toggleControladorStatus(controlador) {
  const novoStatus = controlador.ativo === 1 ? -1 : 1;

  const request = axiosInstance.put(`/controladores/${controlador.id}/status`, {
    ativo: novoStatus,
  });

  return dispatch => {
    request
      .then(resp => {
        console.log('Toggle status sucesso:', resp.data);
        dispatch({ type: 'CONTROLADOR_STATUS_UPDATED', payload: resp });
        toastr.success('Sucesso', `Controlador ${novoStatus === 1 ? 'online' : 'offline'} com sucesso!`);

        // Recarregar a lista após um pequeno delay para garantir que o backend atualizou
        setTimeout(() => {
          console.log('Recarregando lista de controladores...');
          dispatch(getList());
        }, 500);
      })
      .catch(e => {
        console.error('Erro ao alterar status:', e);
        toastr.error('Erro', 'Erro ao alterar status do controlador');
      });
  };
}
